import { WorkScrollJack } from '../../plugins/gsap/work-scroll-jack';

new WorkScrollJack(document.querySelectorAll('.pane--smart-content.pane--gsap'));
